import React from "react";
import { useNavigate } from "react-router-dom";
import "../../css/documents-properties/Main.css";

const Properties = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/documents");
  };

  return (
    <div className="documents-properties-main">
      <div className="box">
        <div className="header">
          <div className="title">PM2100124-LTG531-ER2-00004</div>
          <div className="subtitle">
            PVPLANT - GENERAL - PVSYST - CALCULATION REPORT AND PERFORMANCE
            MODEL
          </div>
          {/* <button className="back-button" onClick={handleBackClick}>
            Back
          </button> */}
        </div>
        <div className="buttons">
          <div className="button1">Viewer</div>
          <div className="button2">Properties</div>
          <div className="button3">Downloaded</div>
        </div>
      </div>
    </div>
  );
};

export default Properties;